export const LOAD_USERS_REQUESTED = "LOAD_USERS_REQUESTED";
export const LOAD_USERS_SUCCEEDED = "LOAD_USERS_SUCCEEDED";
export const LOAD_USERS_FAILED = "LOAD_USERS_FAILED";
export const SAVE_USER_REQUESTED = "SAVE_USER_REQUESTED";
export const SAVE_USER_SUCCEEDED = "SAVE_USER_SUCCEEDED";
export const SAVE_USER_FAILED = "SAVE_USER_FAILED";
export const CLEAR_USER_SAVE_ERROR = "CLEAR_USER_SAVE_ERROR";
export const DELETE_USER_REQUESTED = "DELETE_USER_REQUESTED";
export const DELETE_USER_SUCCEEDED = "DELETE_USER_SUCCEEDED";
export const DELETE_USER_FAILED = "DELETE_USER_FAILED";